import { ChangeDetectorRef, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
//This is needed to update the tinymce editor when the model gets changed
var CUSTOM_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return TinymceEditorDirective; }),
    multi: true
};
// Tinymce directive
var TinymceEditorDirective = /** @class */ (function () {
    //ChangeDetectorRef is used to update angular component tree whenver a blur event occurs to trigger all the validations
    function TinymceEditorDirective(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.val = "";
        //This is used to update the model on view update
        this.ngModelChange = new EventEmitter();
        //All the options needed for tinymce editor
        this.options = {
            plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'print',
                'preview',
                'anchor',
                'searchreplace',
                'visualblocks',
                'code',
                'fullscreen',
                'insertdatetime',
                'media',
                'table',
                'contextmenu',
                'paste'
            ],
            menubar: false,
            toolbar: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | code',
            content_css: [
                '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i'
            ]
        };
        //registerOnChange, registerOnTouched, writeValue are methods need to be implemented for the interface ControlValueAccessor
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    Object.defineProperty(TinymceEditorDirective.prototype, "ngModel", {
        //Getter and setters for NgModel binding
        get: function () {
            return this.val;
        },
        set: function (val) {
            this.val = val;
        },
        enumerable: true,
        configurable: true
    });
    TinymceEditorDirective.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    TinymceEditorDirective.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    //This method is called whenever model gets updated
    TinymceEditorDirective.prototype.writeValue = function (value) {
        //This check is necessary because, this method gets called before editor gets initialised. Hence undefined/null pointer exceptions gets thrown
        if (tinymce.get(this.selector) && value) {
            tinymce.get(this.selector).setContent(value, { format: 'raw' });
        }
    };
    //Update the component tree only when blur event happens. Otherwise following bug will occur.
    //Cursor position changes to 0 or the begining of the editor after every event.
    TinymceEditorDirective.prototype.valueChange = function () {
        this.valueOnChange(false);
    };
    TinymceEditorDirective.prototype.valueOnChange = function (change) {
        this.val = tinymce.activeEditor.getContent();
        this.ngModelChange.emit(this.val);
        if (change) {
            this.changeDetectorRef.detectChanges();
        }
    };
    TinymceEditorDirective.prototype.ngAfterViewInit = function () {
        var that = this;
        var options = this.options;
        if (this.selector) {
            options['selector'] = '#' + this.selector;
        }
        else {
            options['selector'] = ".wysiwyg";
        }
        options['height'] = 500;
        //options['schema'] = "html5";
        options['skin_url'] = "assets/skins/lightgray";
        //write the model value to tinymce editor once gets initialised. And track input and change events
        options['init_instance_callback'] = function (editor) {
            that.writeValue(that.ngModel);
            editor.on('change', function (e) {
                that.valueChange();
            });
            editor.on('blur', function (e) {
                that.valueOnChange(true);
            });
            editor.on('keyup', function (e) {
                that.valueChange();
            });
            editor.on('PastePostProcess', function (e) {
                that.valueChange();
            });
        };
        tinymce.init(options);
    };
    TinymceEditorDirective.ctorParameters = function () { return [{ type: ChangeDetectorRef }]; };
    return TinymceEditorDirective;
}());
export { TinymceEditorDirective };
//# sourceMappingURL=tiny.directive.js.map


// WEBPACK FOOTER //
// tiny.directive.js